export interface INavigationRoute {
  name: string
  displayName: string
  icon: string
  requiresAdmin?: boolean
}

export default {
  routes: [
    {
      name: 'dashboard',
      displayName: '报备',
      icon: 'vuestic-iconset-dashboard',
    },
    {
      name: 'personal-reports',
      displayName: '个人客户报备信息',
      icon: 'va-calendar',
      requiresAdmin: true,
    },
    {
      name: 'company-reports',
      displayName: '企业客户报备信息',
      icon: 'va-calendar',
      requiresAdmin: true,
    },
    {
      name: 'my-personal-reports',
      displayName: '我的个人用户报备',
      icon: 'va-calendar',
    },
    {
      name: 'my-company-reports',
      displayName: '我的企业用户报备',
      icon: 'va-calendar',
    },
  ],
}
